import { ICON_HEIGHT_16 } from '../../../../Icon'

import PanIcon from '../../../../../icons/hand.svg'

export const PDF_VIEWER_TOOLBAR_PAN_ICON_PROPS = {
  Icon: PanIcon,
  svgSize: ICON_HEIGHT_16,
}

export const QA_NAME_PDF_VIEWER_TOOLBAR_PAN_MODE_BTN = 'pdfViewerToolbarPanMode'
